import { useTranslation } from "react-i18next";
import type { OrderingSeatBills } from "./orderingSeatBills";
import { SeatOptionRow } from "./SeatOptionRow";

/**
 * „Как да се водят сметките" при резервация с няколко маси: „Една сметка"
 * (по подразбиране) или „Отделна сметка за всяка маса" — спряната казва
 * защо вместо описанието. Какво ще стане с масите е отдолу (SeatOutcome).
 * ←/→ сменят избора (useSeatModalKeys на родителя).
 */
export const SeatBillsSection = ({
  bills,
  separateBills,
  disabled,
  onChange,
}: {
  bills: OrderingSeatBills;
  separateBills: boolean;
  disabled: boolean;
  onChange: (separateBills: boolean) => void;
}) => {
  const { t } = useTranslation();
  const separateHint = bills.separateHint ? t(bills.separateHint.key, bills.separateHint.params) : null;

  return (
    <div role="radiogroup" aria-label={t("reservations.seatBills.group")} className="flex flex-col gap-2">
      <SeatOptionRow
        title={t("reservations.seatBills.single")}
        meta={t("seatReservation.bills.singleSummary")}
        checked={!separateBills}
        disabled={disabled}
        onClick={() => onChange(false)}
      />
      <SeatOptionRow
        title={t("reservations.seatBills.separate")}
        meta={separateHint ?? t("reservations.seatBills.separateSummary", { count: bills.tableCount })}
        warn={separateHint !== null}
        checked={separateBills}
        disabled={disabled || separateHint !== null}
        onClick={() => onChange(true)}
      />
    </div>
  );
};
